import {
  InputDropdown,
  InputDropdownProps,
} from '@/decodo/components/atoms/InputDropdown';
import { Text } from '@/decodo/components/atoms/Text';
import { cn } from '@/lib/utils';

export type Option = {
  value: string;
  label: string;
  [key: string]: any;
};

interface ProductDropdownProps
  extends Omit<
    InputDropdownProps<Option>,
    'options' | 'renderOption' | 'renderSelectedValue' | 'value'
  > {
  options: Option[];
  value: Option | null;
  onOptionChange: (option?: Option) => void;
  isDisabled?: boolean;
}

export const ProductDropdown = ({
  options,
  value,
  onOptionChange,
  isDisabled,
  classNames,
  ...props
}: ProductDropdownProps) => {
  return (
    <InputDropdown
      isDisabled={isDisabled}
      {...props}
      value={value ? value.value : undefined}
      classNames={{
        ...classNames,
        inputField: {
          ...classNames?.inputField,
          root: cn('text-body-m !h-8', classNames?.inputField?.root),
        },

        root: cn('w-full !h-8 md:pl-9', classNames?.root),
      }}
      placeholder='Select product'
      popoverProps={{
        classNames: {
          childrenWrapper: 'w-full shadow-card',
        },
        contentProps: {
          avoidCollisions: true,
        },
      }}
      hasSearch
      options={options}
      onOptionChange={(val) => {
        const selectedOption = options.find((o) => o.value === val);
        onOptionChange(selectedOption);
      }}
      renderOption={({ option }) => (
        <div className='flex items-center gap-x-2.5'>
          <Text variant='body-m'>{option.label}</Text>
        </div>
      )}
      renderSelectedValue={({ option }) => (
        <Text variant='body-m'>{option.label}</Text>
      )}
    />
  );
};
